module.exports = __webpack_public_path__ + "static/media/sunday-independent.da372855.svg";